import { Tooltip } from "@mui/material";
import { useMxFieldControllerContext } from "../../../context/MxFieldController";
import HCheckArray from "@rf-helper/check-have-value";
import MxIcons from "@rf-l1/MxIcons";
import { IconAlertCircle, IconAlertTriangleFilled } from "@tabler/icons-react";
import MxTooltipContent from "@rf-l1/tooltip/MxTooltipContent";
import MxTooltipItemInfo from "@rf-l1/tooltip/MxTootipitemInfo";
export interface IMxErrorMessageProps {
  formatMsg?: (msg: string) => string;
  formatLabel?: (label: string) => string;
}
const MxFormErrorIconsMessage = (props: IMxErrorMessageProps) => {
  const { error, name } = useMxFieldControllerContext();

  if (typeof error == "undefined") return <></>;
  if (!error) return <></>;

  return (
    <MxTooltipContent
      template={
        <MxTooltipItemInfo
          type="ERROR"
          label={props.formatLabel ? props.formatLabel(name) : name}
          value={error.message ?? ""}
        />
      }
    >
      <MxIcons color="warning.main">
        <IconAlertTriangleFilled />
      </MxIcons>
    </MxTooltipContent>
  );
};

export default MxFormErrorIconsMessage;
